export const GIVING_SIDE_EMAIL = "my@givingside.com"

